/**
 * ConsentScripts — script-loading gateway driven by the consent state.
 *
 * THIS FILE INTENTIONALLY DOES NOT INCLUDE ANY THIRD-PARTY TRACKING.
 * It exposes documented plug-in points so future analytics / pixel / clarity
 * integrations can be added without rewriting consent infrastructure.
 *
 * Usage pattern (when you wire a real provider later):
 *
 *   if (consent.analytics)   loadGoogleAnalytics(GA_ID);
 *   if (consent.analytics)   loadMicrosoftClarity(CLARITY_ID);
 *   if (consent.marketing)   loadMetaPixel(PIXEL_ID);
 *   if (consent.marketing)   loadGoogleAdsConversion(AW_ID);
 *
 * The component listens to consent changes (via the React context AND the
 * window event `ads-dashbound:consent-changed`) so external scripts can also
 * subscribe without React.
 */
import { useEffect, useRef } from 'react';
import { useConsent } from '@/lib/consent';

export default function ConsentScripts() {
  const { consent, decided } = useConsent();
  const lastApplied = useRef({ analytics: null, marketing: null, preferences: null });

  useEffect(() => {
    if (!decided) return;
    const next = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
    };
    const changed =
      lastApplied.current.analytics !== next.analytics ||
      lastApplied.current.marketing !== next.marketing ||
      lastApplied.current.preferences !== next.preferences;
    if (!changed) return;
    lastApplied.current = next;

    // -----------------------------------------------------------------
    // Plug-in points — uncomment / extend when real IDs are configured.
    // -----------------------------------------------------------------
    // if (next.analytics) {
    //   /* loadGoogleAnalytics(process.env.REACT_APP_GA_ID); */
    //   /* loadMicrosoftClarity(process.env.REACT_APP_CLARITY_ID); */
    // } else {
    //   /* unloadGoogleAnalytics(); */
    //   /* unloadMicrosoftClarity(); */
    // }
    // if (next.marketing) {
    //   /* loadMetaPixel(process.env.REACT_APP_META_PIXEL_ID); */
    //   /* loadGoogleAdsConversion(process.env.REACT_APP_GADS_ID); */
    // } else {
    //   /* unloadMetaPixel(); */
    //   /* unloadGoogleAdsConversion(); */
    // }
    // if (next.preferences) {
    //   /* loadPreferenceCookies(); */
    // }
  }, [consent.analytics, consent.marketing, consent.preferences, decided]);

  return null;
}
